import React from "react";
import useProductInfo from "@widgets/pos/order/menu/product/context/ProductInfoProvider";
import ProductFlag from "@widgets/pos/order/menu/product/flags/ProductFlag";
import {FormattedMessage} from "react-intl";


const ProductFlags = () => {
    const {product} = useProductInfo();

    if (product.flags.length === 0) {
        return <></>;
    }

    return (
        <div className={"w-full flex flex-col gap-1 items-start justify-start"}>
            <p className={"font-medium"}>
                <FormattedMessage id={"allergens-dietary-preferences"}/>
            </p>

            <ul
                className={"w-full flex flex-row flex-wrap items-end justify-start gap-2 font-medium text-gray-500 text-eat-xs"}
            >
                {product.flags.sort().map((flagName: string, index: number) => (
                    <ProductFlag
                        key={index}
                        name={flagName}
                    />
                ))}
            </ul>
        </div>
    );
};

export default ProductFlags;